import {registerGlobalInitFunc} from '../modules/observer.ts';
import {toggleElem} from '../utils/dom.ts';

// A token limited to public repositories is read-only: while that option is chosen, no write permission can be picked.
function initFineGrainedTokenForm(form: HTMLElement): void {
  const publicOnly = form.querySelector<HTMLInputElement>('input[name="repo_selection"][value="public"]')!;
  const sync = () => {
    for (const write of form.querySelectorAll<HTMLInputElement>('input[type="radio"][value="write"]')) {
      write.disabled = publicOnly.checked;
      if (publicOnly.checked && write.checked) {
        form.querySelector<HTMLInputElement>(`input[type="radio"][name="${CSS.escape(write.name)}"][value="read"]`)!.checked = true;
      }
    }
  };
  for (const radio of form.querySelectorAll<HTMLInputElement>('input[name="repo_selection"]')) {
    radio.addEventListener('change', sync);
  }
  sync();

  // Some permissions need a token owned by the person and some one owned by an organization: the rows the chosen
  // owner cannot have are not shown, and what was picked in them is cleared and not submitted.
  const owner = form.querySelector<HTMLSelectElement>('select[name="owner_id"]');
  if (!owner) return;
  const syncOwner = () => {
    const isOrg = owner.selectedOptions[0]?.getAttribute('data-org') === 'true';
    // a token owned by an organization needs the approval of its approvers before it reaches private repositories or writes
    toggleElem(form.querySelector('#fg-approval-notice')!, isOrg);
    for (const row of form.querySelectorAll<HTMLElement>('tr[data-org-only], tr[data-personal-only]')) {
      const unavailable = isOrg ? row.getAttribute('data-personal-only') === 'true' : row.getAttribute('data-org-only') === 'true';
      toggleElem(row, !unavailable);
      for (const radio of row.querySelectorAll<HTMLInputElement>('input[type="radio"]')) {
        radio.disabled = unavailable;
        if (unavailable) radio.checked = radio.value === '';
      }
    }
  };
  owner.addEventListener('change', syncOwner);
  syncOwner();
}

export function initFineGrainedTokenForms(): void {
  registerGlobalInitFunc('initFineGrainedTokenForm', initFineGrainedTokenForm);
}
